module.exports = __webpack_public_path__ + "img/13_10.b99d4faf.png";